<mat-card *ngIf="invest">
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{ 'invest.projects.title.shortLabel' | translate }}
                <app-tooltip text="{{'invest.projects.title.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <app-sic-projects *ngIf="invest.simulation.provider !== providerType.bbc"
            [invest]="invest"></app-sic-projects>
        <app-bbc-projects *ngIf="invest.simulation.provider === providerType.bbc"
            [invest]="invest"></app-bbc-projects>
    </mat-card-content>
</mat-card>

<section *ngIf="invest" class="actions">
    <button mat-raised-button color="accent" class="add-btn"
        *ngIf="!isLoading && provider === 'bbc2020'"
        [matTooltip]="'invest.calculate.summary' | translate"
        (click)="eval()">
        <mat-icon aria-label="Eval">play_arrow</mat-icon>
        {{ 'invest.calculate.fullLabel' | translate }}
    </button>
    <button mat-raised-button color="accent" class="add-btn"
        *ngIf="!isLoading && provider !== 'bbc2020'"
        [matTooltip]="'invest.calculateSic.summary' | translate"
        (click)="eval()">
        <mat-icon aria-label="Eval">play_arrow</mat-icon>
        {{ 'invest.calculateSic.fullLabel' | translate }}
    </button>
    <mat-spinner *ngIf="isLoading" [diameter]="35" color="accent" ></mat-spinner>
</section>
